import { apiAxios } from "@/api/axios";
import base from '../config'
let baseURL = base.baseURL

export default {
  //日本事务所-权限列表
  getAuthFieldList: (data) => apiAxios('post', baseURL + '/jpanfirm.getAuthFieldList', data),
  //日本事务所-权限设置
  setAuthField: (data) => apiAxios('post', baseURL + '/jpanfirm.setAuthField', data),
  //日本事务所-客户基础信息查询
  clientInfo: (data) => apiAxios('post', baseURL + '/jpanfirm.clientInfo', data),
  //日本事务所-订单列表
  orderList: (data) => apiAxios('post', baseURL + '/jpanfirm.orderList', data),
  //日本事务所-配送单列表
  porderList: (data) => apiAxios('post', baseURL + '/jpanfirm.porderList', data),
  //日本事务所-出入金列表
  userBillList: (data) => apiAxios('post', baseURL + '/jpanfirm.userBillList', data),
  //日本事务所-客户反馈
  feedbackList: (data) => apiAxios('post', baseURL + '/jpanfirm.feedbackList', data),
  //日本事务所-客户评价
  evaluationList: (data) => apiAxios('post', baseURL + '/jpanfirm.evaluationList', data),
  //日本事务所-发送邮件
  sendEmail: (data) => apiAxios('post', baseURL + '/jpanfirm.sendEmail', data),
  //日本事务所-客户邮件列表
  emailList: (data) => apiAxios('post', baseURL + '/jpanfirm.emailList', data),
  //日本事务所-邮件详情
  emailDetail: (data) => apiAxios('post', baseURL + '/jpanfirm.emailDetail', data),

  /* 日本事务所-咨询 */
  //日本事务所-咨询列表-可选来源
  source: (data) => apiAxios('post', baseURL + '/consult.source', data),
  //日本事务所-咨询列表-可选分类
  category: (data) => apiAxios('post', baseURL + '/consult.category', data),
  //日本事务所-咨询列表
  consultList: (data) => apiAxios('post', baseURL + '/consult.list', data),
  //日本事务所-咨询-添加
  consultStore: (data) => apiAxios('post', baseURL + '/consult.store', data),
  //日本事务所-咨询-修改
  consultUpdate: (data) => apiAxios('post', baseURL + '/consult.update', data),
  //日本事务所-咨询-删除
  consultDelete: (data) => apiAxios('post', baseURL + '/consult.delete', data),
  //日本事务所-修改日本事务所备注
  updateJapanfirmRemark: (data) => apiAxios('post', baseURL + '/jpanfirm.updateJapanfirmRemark', data),


}